import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";
import {
    Paper,
    Box,
    Typography,
    Button,
} from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

import {
    ATTESTATION_STATUS,
    Attestation,
    detectAttestationStatus,
    isFailed,
    isUpcomming
} from '../../../common/attestsation';
import APP_URLs from '../../../consts/url';

const View = ({attestation}: {attestation: Attestation}) => {
    const [status, setStatus] = useState(ATTESTATION_STATUS.NOT_FOUND);
    useEffect(() => {
        setStatus(
            detectAttestationStatus(attestation)
        )
    }, [attestation]);

    const formatDate = (date: string): string => {
        const parsedDate = new Date(date);
        const fulfillVal = (val: string) => val.length < 2 ? `0${val}` : val;
        return `${fulfillVal(String(parsedDate.getHours()))}:${fulfillVal(String(parsedDate.getUTCMinutes()))} ${parsedDate.getDate()}.${parsedDate.getMonth() + 1}`;
    };
    return status === ATTESTATION_STATUS.NOT_FOUND || !status
    ? null
    : (
        <Paper
            sx={{
                p: 2,
                mb: 2,
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                ...(isUpcomming(status) ? {
                    pointerEvents: 'none',
                    opacity: '0.6',
                    backgroundColor: '#d8d0d0',
                } : {

                }),
            }}
            elevation={1}
            component={status === ATTESTATION_STATUS.ACTUAL_FAILED ? Link : 'div'}
            to={status === ATTESTATION_STATUS.ACTUAL_FAILED ? `${APP_URLs.ATTESTAITON}/${attestation.id}` : undefined}
        >
            <Box>
                <Box>
                    <Typography
                        component='h2'
                        sx={{
                            fontWeight: 'bold',
                            fontSize: '1.4rem',
                            color: 'secondary.dark',
                            marginBottom: '0.5em',
                        }}
                    >
                        {attestation.name}
                    </Typography>
                </Box>
                {!attestation.lastSubmission?.sealed ? (
                    <Box sx={{display: 'flex', alignItems: 'center'}}>
                        <CalendarMonthIcon sx={{marginRight: 1}} fontSize='large'/>
                        {attestation.lastSubmission.startsAt && <Typography> Сдать до {formatDate(attestation.lastSubmission.endsAt)}</Typography>}
                    </Box>
                ) : (
                    <Box sx={{display: 'flex', alignItems: 'center'}}>
                        {isFailed(status) ? (
                           <CloseIcon color="error" fontSize='large'/>
                        ) : (
                            <CheckIcon color="success" fontSize='large'/>
                        )}
                        {/* @ts-expect-error */}
                        {attestation.lastSubmission.results?.score} из {attestation.lastSubmission.results?.maxScore}
                    </Box>
                )}
            </Box>
            {status === ATTESTATION_STATUS.ACTUAL_FAILED && <Button sx={{marginLeft: 'auto'}} variant="contained">Начать</Button>}
        </Paper>
    )
}

export default View;